import React, { Component } from 'react'
import { withStyles, Typography, Grid } from '@material-ui/core'
import format from 'date-fns/format'

const styles = theme => ({
  root: {
    textAlign: 'left'
  },
  serviceList: {
    margin: 0,
    paddingLeft: theme.spacing.unit * 3
  },
  title: {
    marginTop: theme.spacing.unit
  },
  extraDescription: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
})

const stagioneLabels = {
  estivi: 'Estivi',
  invernali: 'Invernali',
  '4stagioni': '4 stagioni'
}

const tipoLabels = {
  auto: 'Auto',
  '4x4': '4x4',
  trasporto_leggero: 'Trasporto leggero'
}

export class BookingReviewBase extends Component {
  render() {
    const { classes, booking } = this.props

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={6}>
            <Typography className={classes.title} variant="h6">
              Servizi prenotati
            </Typography>
            <ul className={classes.serviceList}>
              {booking.services.map((service, index) => (
                <li key={service.id}>
                  <Typography
                    gutterBottom={index === booking.services.length - 1}
                  >
                    {service.descrizione} {service.descrizioneAggiuntiva && <span className={classes.extraDescription}> - {service.descrizioneAggiuntiva}</span>}
                  </Typography>
                </li>
              ))}
            </ul>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography className={classes.title} variant="h6">
              Giorno ed ora
            </Typography>
            <Typography>
              <b>Giorno:</b> {format(booking.selectedDay, 'DD-MM-YYYY')}
            </Typography>
            <Typography gutterBottom>
              <b>Ora:</b> {booking.selectedHour.descrizione}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            {' '}
            <Typography className={classes.title} variant="h6">
              Dati cliente
            </Typography>
            <Typography>
              <b>Nome:</b> {booking.userData.nome}
            </Typography>
            <Typography>
              <b>Cognome:</b> {booking.userData.cognome}
            </Typography>
            <Typography>
              <b>Email:</b> {booking.userData.email}
            </Typography>
            <Typography gutterBottom>
              <b>Telefono:</b> {booking.userData.telefono}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography className={classes.title} variant="h6">
              Dati Veicolo
            </Typography>
            <Typography>
              <b>Marca:</b> {booking.userData.marcaVeicolo}
            </Typography>
            <Typography>
              <b>Modello:</b> {booking.userData.modelloVeicolo}
            </Typography>
            {booking.userData.targaVeicolo && (
              <Typography>
                <b>Targa:</b> {booking.userData.targaVeicolo}
              </Typography>
            )}
            {booking.userData.larghezzaPneumatico && (
              <Typography>
                <b>Larghezza:</b> {booking.userData.larghezzaPneumatico}
              </Typography>
            )}
            {booking.userData.altezzaPneumatico && (
              <Typography>
                <b>Altezza:</b> {booking.userData.altezzaPneumatico}
              </Typography>
            )}
            {booking.userData.diametroPneumatico && (
              <Typography>
                <b>Diametro:</b> {booking.userData.diametroPneumatico}
              </Typography>
            )}
            {booking.userData.indiceVelocitaPneumatico && (
              <Typography>
                <b>Indice velocita:</b>{' '}
                {booking.userData.indiceVelocitaPneumatico}
              </Typography>
            )}
            {booking.userData.stagionePneumatico && (
              <Typography>
                <b>Stagione:</b>{' '}
                {stagioneLabels[booking.userData.stagionePneumatico]}
              </Typography>
            )}
            {booking.userData.tipoPneumatico && (
              <Typography>
                <b>Tipo preumatico:</b>{' '}
                {tipoLabels[booking.userData.tipoPneumatico]}
              </Typography>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export const BookingReview = withStyles(styles)(BookingReviewBase)
